import { t, useStoreLanguage, getLocale } from "../../../features/store-language/i18n.ts";
import React from "react";
import AuthenticatedImage from "../../shared/AuthenticatedImage.tsx";

export interface VariantImage {
  id: number;
  mainImageMediaId: number;
  thumbnailMediaId?: number | null;
}

interface Props {
  images?: VariantImage[];
  selected: string | number | null;
  onSelect: (fileId: string) => void;
}

export default function VariantImageChoices({ images = [], selected, onSelect }: Props) {
  useStoreLanguage();
  if (images.length < 2) { return null; }
  return (
    <div
      className="schema-variant-image-choices"
      role="group"
      aria-label={t("تصاویر این کالا")}
    >
      {images.map(function (image, index) {
        const fileId = `store:${image.mainImageMediaId}`;
        return (
          <button
            key={image.id}
            type="button"
            aria-pressed={selected === fileId}
            title={t("تصویر {{value0}}", { value0: (index + 1).toLocaleString(getLocale()) })}
            onClick={function (event) {
              event.stopPropagation();
              onSelect(fileId);
            }}
          >
            <AuthenticatedImage
              fileId={`store:${image.thumbnailMediaId || image.mainImageMediaId}`}
              disablePreview={true}
              alt={t("انتخاب تصویر {{value0}}", { value0: (index + 1).toLocaleString(getLocale()) })}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </button>
        );
      })}
    </div>
  );
}
